import { AUTH_LOGIN, CAMPAIGNS, CAMPAIGN_DETAILS, CAMPAIGN_EDIT, CAMPAIGN_DELETE,
  CAMPAIGNS_ENABLE, CAMPAIGNS_DISABLE, CAMPAIGNS_DELETE,
  NOTIFICATIONS_INCLUDE, REPORTS_DOWNLOAD } from '@store/types'
import store from '@store'

const notify = (type = 'success', ...args) => {
  const [ payload, action ] = args
  const status = type === 'success' ? 'success' : 'failure'
  const getMessage = messages[action] && messages[action][status]
  const message = typeof getMessage === 'function' ? getMessage(...args) : getMessage

  if (message) {
    store.dispatch(NOTIFICATIONS_INCLUDE, { message, type })
  }

  return Promise.resolve(type === 'success' ? payload : null)
}

export const onSuccess = (...args) => notify('success', ...args)

export const onFailure = (...args) => notify('error', ...args)

const messages = {
  [AUTH_LOGIN]: {
    failure: 'Login e/ou senha não encontrados.'
  },
  [CAMPAIGNS]: {
    failure: 'Não foi possível obter as ofertas.'
  },
  [CAMPAIGN_DETAILS]: {
    failure: 'Não foi possível obter os detalhes da oferta.'
  },
  [CAMPAIGN_EDIT]: {
    failure: 'Não foi possível alterar os detalhes da oferta.'
  },
  [CAMPAIGN_DELETE]: {
    failure: 'Não foi possível excluir a oferta.',
    success: 'A oferta foi excluída!'
  },
  [CAMPAIGNS_ENABLE]: {
    failure: 'Não foi possível ativar as ofertas.',
    success: 'As ofertas foram ativadas!'
  },
  [CAMPAIGNS_DISABLE]: {
    failure: 'Não foi possível desativar as ofertas.',
    success: 'As ofertas foram desativadas!'
  },
  [CAMPAIGNS_DELETE]: {
    failure: 'Não foi possível excluir as ofertas.',
    success: 'As ofertas foram excluídas!'
  },
  [REPORTS_DOWNLOAD]: {
    failure: 'Não foi possível obter o relatório.',
    success: 'O relatório foi enviado para o email cadastrado!'
  }
}



// WEBPACK FOOTER //
// ./src/store/handlers.js